import fetch from "isomorphic-fetch"
import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink, from } from "@apollo/client"
import { navigate } from "gatsby"
import { isEmpty } from "lodash"
import { onError } from "@apollo/client/link/error"

/**
 * Woo returns headers like "Session abc123". Normalize anything we stored before
 * (including double-prefixed values) to a single "Session <token>" string.
 */
const normalizeWooSession = sessionValue => {
  if (isEmpty(sessionValue)) {
    return null
  }

  const trimmed = sessionValue.trim()
  if (trimmed.toLowerCase() === "false") {
    return null
  }

  const token = trimmed.replace(/^(session\s*)+/i, "").trim()
  return token ? `Session ${token}` : null
}

const afterwareLink = new ApolloLink((operation, forward) => {
  return forward(operation).map(response => {
    const context = operation.getContext()
    const {
      response: { headers }
    } = context
    const rawSession = context.response.headers.get("woocommerce-session")
    const normalizedSession = normalizeWooSession(rawSession)

    if (rawSession) {
      // Remove session data if session destroyed.
      if (!normalizedSession) {
        localStorage.removeItem("woo-session")

        // Update session new data if changed.
      } else if (localStorage.getItem("woo-session") !== normalizedSession) {
        localStorage.setItem("woo-session", normalizedSession)
      }
    }

    return response
  })
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors)
    graphQLErrors.forEach(error => {
      const { locations, message, path } = error
      console.warn(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      if (typeof message === "string" && message.toLowerCase().includes("failed to decode session token")) {
        // Session token is invalid/expired; clear it so Woo will issue a fresh one.
        localStorage.removeItem("woo-session")
      }
      if (message === "Internal server error") {
        localStorage.removeItem("auth")
        sessionStorage.removeItem("isLogged")
        if (window.location.pathname === "/") {
          window.location.reload()
        } else {
          navigate("/")
        }
      }
    })

  if (networkError) console.warn(`[Network error]: ${networkError}`)
})
const httpLink = createHttpLink({
  uri: "https://admin.backa.com.au/graphql",
  // uri: "https://74.arrowhitech.net/g3/backa/graphql",
  fetch
})

const midd = new ApolloLink((operation, forward) => {
  let headersData = null

  const storedSession = localStorage.getItem("woo-session")
  const normalizedSession = normalizeWooSession(storedSession)
  if (normalizedSession) {
    // Clean up any legacy stored values so future requests stay valid.
    if (storedSession !== normalizedSession) {
      localStorage.setItem("woo-session", normalizedSession)
    }

    headersData = {
      // Normalized value always includes a single `Session` prefix.
      "woocommerce-session": normalizedSession
    }
  }
  const auth = JSON.parse(localStorage.getItem("auth"))
  const token = !isEmpty(auth) ? auth.authToken : null
  // const auth=JSON.parse(auth1)

  if (!isEmpty(token)) {
    headersData = {
      ...headersData,
      authorization: token ? `Bearer ${token}` : ""
    }
  }

  if (!isEmpty(headersData)) {
    operation.setContext(() => ({
      headers: headersData
    }))
  }

  return forward(operation)
})

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: midd.concat(afterwareLink.concat(from([errorLink, httpLink])))
})

export default client
